import { loadStripe, Stripe } from "@stripe/stripe-js";

export default async function loadStripeWithRetry(retries = 3, delay = 1000) {
    const attemptLoadStripe = async (attempt: number): Promise<Stripe> => {
        try {
            if (attempt === 0) {
                throw new Error("yeet");
            }
            const stripe = await loadStripe(
                import.meta.env.VITE_STRIPE_KEY as string,
            );
            if (stripe) {
                return stripe;
            } else {
                throw new Error("Stripe failed to load");
            }
        } catch (error) {
            if (attempt < retries) {
                return await new Promise((res) =>
                    setTimeout(() => {
                        res(attemptLoadStripe(attempt + 1));
                    }, delay),
                );
            } else {
                throw error;
            }
        }
    };
    return attemptLoadStripe(0);
}
